<template>
  <div id="app">
    <!--头部-->
    <hd v-if="isHeader"></hd>
    <hdb v-else></hdb>
    <!--主题内容-->
    <router-view />
    <!--底部-->
    <ft></ft>

  </div>
</template>

<script>
import jq from '@/plugins/jquery-1.11.3.min'
// import layout from '@/components/layout/layout.vue'
import hd from '@/components/header/header.vue'
import hdb from '@/components/header/header-back.vue'
import ft from '@/components/footer/footer.vue'

export default {
  name: 'App',
  data: () => ({
    name: '',
    isHeader:true
  }),
  methods: {
  },
  //     dom挂载之后
  mounted () {
    this.$nextTick(() => {
    })
  },
  //    dom挂载之前
  created () {

  },
  //    组件
  components: {
    hd,
    hdb,
    // layout,
    ft
  },
  //    计算函数
  computed: {

  },
  //  监听路由  有变化 自动跳转到页面顶部
  watch: {
    '$route': function (to, from) {
      document.body.scrollTop = '0';
      if(to.path.indexOf('system') != -1 || to.path.indexOf('setup') != -1){
          this.isHeader = false;        
      }else{
          this.isHeader = true;
      }
    }
  }
}
</script>

<style>
@import "style/css/main.css";
@import "style/css/module/animate.css";
.jiathis_style > table {
  display: none !important;
}

#app {
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue